<template>
  <div>
    <conditional-slider
      :slides="filteredOptions"
      slideKey="title"
      :itemsPerSlide="params.itemsPerSlide || 5"
      :enabled="!params.disableSlide && true"
      :class="params.compact ? 'compact' : ''"
      :selected-option="selectedOption"
      :button-inside="params.buttonInside"
      :gtm="gtm"
    >
      <template v-slot="{ slide: option }">
        <div>
          <label
            v-if="!isAbsoluteUrl(option.outcome + '')"
            :class="'label ' + (option.disabled ? 'label--disabled' : '')"
          >
            <input
              :type="multi ? 'checkbox' : 'radio'"
              :name="name"
              :value="option"
              v-model="selectedOption"
              :disabled="option.disabled"
            />
            <div class="box" :class="[multi ? 'box--multi' : '']">
              <div
                v-if="option.image != null"
                class="box-icon"
                :class="[
                  !option.image.endsWith('.svg') ? 'box-icon--no-svg' : ''
                ]"
                :style="{
                  maskImage: 'url(' + getAssetUrl(option.image) + ')',
                  backgroundImage: 'url(' + getAssetUrl(option.image) + ')'
                }"
              ></div>
              <span
                v-if="option.subtitle"
                class="box-subtitle"
                v-html="option.subtitle"
              ></span>
              <span class="box-title" v-html="option.title"></span>
              <span v-if="multi" class="box-checkbox"></span>
            </div>
          </label>
          <a v-else :href="option.outcome" target="_blank" class="label">
            <input
              type="radio"
              :name="name"
              :value="option"
              v-model="selectedOption"
            />
            <div class="box" :class="[multi ? 'box--multi' : '']">
              <div
                v-if="option.image != null"
                class="box-icon"
                :class="[
                  !option.image.endsWith('.svg') ? 'box-icon--no-svg' : ''
                ]"
                :style="{ maskImage: 'url(' + getAssetUrl(option.image) + ')' }"
              ></div>
              <span
                v-if="option.subtitle"
                class="box-subtitle"
                v-html="option.subtitle"
              ></span>
              <span class="box-title" v-html="option.title"></span>
              <span v-if="multi" class="box-checkbox"></span>
            </div>
          </a>
        </div>
      </template>
    </conditional-slider>
  </div>
</template>

<script>
import isAbsoluteUrl from "@/utils/isAbsoluteUrl";
import imagePath from "@/mixins/imagePath";
import ConditionalSlider from "@/components/ConditionalSlider";

export default {
  components: {
    ConditionalSlider
  },
  mixins: [imagePath],
  props: {
    options: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    result: {
      type: Object,
      required: false
    },
    params: {
      type: Object,
      required: false,
      default: () => new Object()
    },
    multi: {
      type: Boolean,
      required: false,
      default: false
    },
    gtm: {
      required: true
    }
  },
  data() {
    return {
      selectedOptionData: this.multi ? [] : this.result
    };
  },
  computed: {
    selectedOption: {
      get() {
        return this.selectedOptionData;
      },
      set(val) {
        if (this.multi) {
          const oldExclusive = this.selectedOptionData.find(
            option => option.exclusive
          );
          const newExclusive = val.find(option => option.exclusive);

          if (oldExclusive) {
            val = val.filter(option => option !== oldExclusive);
          } else if (newExclusive) {
            this.selectedOptionData = [newExclusive];
            return;
          }
        }

        this.selectedOptionData = val;
      }
    },
    currentStepIndex() {
      return this.$store.getters.currentStepIndex;
    },
    firstOption() {
      return window.FIRST_CHOICE_BRANCHE_ID;
    },
    filteredOptions() {
      let filteredOptions = this.options.concat();

      if (this.params.random) {
        filteredOptions.sort(function() {
          return 0.5 - Math.random();
        });
      }

      if (this.firstOption) {
        let index = filteredOptions.findIndex(
          el => el.brancheId == this.firstOption
        );
        filteredOptions.splice(0, 0, filteredOptions.splice(index, 1)[0]);
      }

      return filteredOptions;
    }
  },
  methods: {
    isAbsoluteUrl(url) {
      return isAbsoluteUrl(url);
    }
  },
  watch: {
    selectedOption(val) {
      this.$emit("change", val);
    }
  }
};
</script>

<style lang="scss" scoped>
.box {
  @extend %box;

  .choice--small & {
    padding: 15px;

    .box-icon {
      width: 50px;
      height: 48px;
    }

    .box-title {
      font-size: 13px;
    }
  }

  &--multi {
    .box-checkbox {
      position: relative;
      display: block;
      width: 20px;
      height: 20px;
      margin: 25px auto 15px;
      background: transparent;
      box-shadow: 0 0 0 2px currentColor;
      border-radius: 2px;
      transition: mask $s-transition;

      &::before {
        content: "";
        position: absolute;
        left: 50%;
        top: 50%;
        width: 70%;
        height: 80%;
        transform: translate(-50%, -50%);
      }
    }
  }
}

.label {
  display: block;
  all: unset;
  height: 100%;
  width: 100%;

  &--disabled {
    .box {
      cursor: default;
      box-shadow: none;
    }

    .box-icon,
    .box-title {
      opacity: 0.5;
    }

    .box-subtitle {
      opacity: 0.6;
    }
  }
}

.label:not(.label--disabled):hover {
  .box {
    @extend %box-hover;
  }

  .box-icon {
    @supports (-ms-ime-align: auto) {
      filter: brightness(100);
    }
  }
}

.box-icon {
  width: 50px;
  height: 40px;
  margin-bottom: 20px;
  background: no-repeat center/contain;

  &:not(.box-icon--no-svg) {
    mask-size: contain;
    mask-repeat: no-repeat;
    mask-position: center;
    background-color: currentColor;
    @supports (mask: url("")) and (not (-ms-ime-align: auto)) {
      background-image: none !important;
    }

    @include ie-only {
      background-color: transparent !important;
    }

    @supports (-ms-ime-align: auto) {
      background-color: transparent !important;
    }
  }

  &--no-svg {
    mask-image: none !important;
  }

  @include media(">=desktop") {
    width: 75px;
    height: 64px;
  }
}

.box-title {
  width: 100%;
  white-space: pre-wrap;
}

.box-subtitle {
  text-transform: uppercase;
  font-size: 14px;
  margin-bottom: 10px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  padding: 5px 10px;
  background: $c-white-contrast;
  color: rgba($c-white, 0.8);
}

input[type="radio"],
input[type="checkbox"] {
  display: none;

  &:checked {
    + .box {
      box-shadow: $s-box-shadow, 0 0 0 5px inset $c-primary;
      color: $c-primary;

      &--multi {
        .box-checkbox {
          &::before {
            background: currentColor;
            mask: url("~@/assets/images/check.svg") no-repeat center/contain;

            @include ie-only {
              mask: none;
              background: url("~@/assets/images/check.svg") no-repeat
                center/contain;
            }
          }
        }
      }
    }
  }
}

@include media(">=tablet") {
  .compact {
    ::v-deep .choice__col {
      padding: 7px;
    }

    .box {
      flex-direction: row;
      padding: 10px;
      padding-left: 70px;
    }

    .box-title {
      font-size: 16px;
    }

    .box-icon {
      width: 50px;
      height: 50px;
      margin: 0;
      margin-right: 5px;
    }

    .box-checkbox {
      position: absolute;
      left: 30px;
      top: 50%;
      transform: translateY(-50%);
      margin: 0;
    }
  }
}
</style>
